import { bookingConstants } from '../utils/types';

import { bookingSessionEventStatuses } from '../utils/constants';

export default function singleSessionEventBooking(
  state = { status: null },
  action
) {
  switch (action.type) {
  case bookingConstants.SESSION_EVENT_BOOKING_REQUEST:
    return {
      status: bookingSessionEventStatuses.BOOKING
    };
  case bookingConstants.SESSION_EVENT_BOOKING_SUCCESS:
    return {
      status: bookingSessionEventStatuses.COMPLETED
    };
  case bookingConstants.SESSION_EVENT_BOOKING_FAILURE:
    return {
      status: bookingSessionEventStatuses.FAILED,
      error: action.payload.error
    };
  case bookingConstants.SESSION_EVENT_BOOKING_RESET:
    return {
      status: bookingSessionEventStatuses.STARTED
    };
  default:
    return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/sessionEventBookingReducer.js